//Module Keys
let locales = {};

//Merge Views
import unsubscribedContactsMain from '../../views/main/lan/en';
import createUnsubscribedContact from 'Modules/unsubscribedContacts/.components/createUnsubscribedContact/lan/en';
import deleteUnsubscribedContact from 'Modules/unsubscribedContacts/.components/deleteUnsubscribedContact/lan/en';


locales = { 
    ...locales,
    ...unsubscribedContactsMain, 
    ...createUnsubscribedContact, 
    ...deleteUnsubscribedContact,
};

export default locales;